import React from "react";

const Central = () => {
  return (
    <div>

      {/* HERO */}
      <section className="hero">
        <div className="container">
          <h1>Central Government Subsidy</h1>
          <p>Central schemes approval consultancy</p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="section">
        <div className="container">

          <h2>Central Subsidy Support</h2>

          <p>
            We assist industries in applying for central government
            schemes and reimbursements under various policies.
          </p>

          <br />

          <div className="card">
            <h3>Our Assistance Includes</h3>
            <p>✔ Scheme selection</p>
            <p>✔ Documentation preparation</p>
            <p>✔ Application submission</p>
            <p>✔ Claim processing</p>
          </div>

        </div>
      </section>

    </div>
  );
};

export default Central;
